import { render, staticRenderFns } from "./CCNpcItemCard.vue?vue&type=template&id=026054e5&"
import script from "./CCNpcItemCard.vue?vue&type=script&lang=js&"
export * from "./CCNpcItemCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports